import * as types from "../actions/actionTypes";
import { IActivityState, InitialState } from "./state";

const handles = {
  [types.ACTIVITIES_GET_FULFILLED]: (state, { activities }) => ({
    ...state,
    activities,
  }),
};

export default function activitiesReducer(
  state: IActivityState = InitialState.activities,
  action,
) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
